import React from 'react'
import Network from '../components/Network'
import page from '~utils/page'
import { NETWORK } from '~shared/Nav'
import Head from '~shared/Head'

// eslint-disable-next-line import/no-unused-modules
export default page(Network, {
    highlight: NETWORK,
    streamrClient: true,
    headComponent: (
        <Head
            // eslint-disable-next-line max-len
            description="The Streamr Network is a scalable real-time messaging system that can power data-driven applications. Build on the Layer 0 protocol for Web 3."
            mediaDescription="Powering Web3 real-time data"
        />
    ),
})
